<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="m6.075 10.005 2.122-2.123-5.265-5.257a3.006 3.006 0 0 0 0 4.245l3.143 3.135Zm5.085-1.357c1.147.532 2.76.157 3.953-1.035 1.432-1.433 1.71-3.488.607-4.59-1.095-1.096-3.15-.826-4.59.607-1.193 1.192-1.568 2.805-1.035 3.952l-7.32 7.32 1.057 1.058L9 10.807l5.16 5.16 1.057-1.057-5.16-5.16 1.103-1.102Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
